import { JSX } from 'react';
import { IconCtaLeftAligned } from '@ahc-digital/component-library';
import { CreateIconCTALeftAlignedModel } from './C33IconCTALeftAligned.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C33IconCTALeftAlignedProps } from './C33IconCTALeftAligned.types';

const Default = (props?: C33IconCTALeftAlignedProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <IconCtaLeftAligned
      {...CreateIconCTALeftAlignedModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C33IconCTALeftAlignedProps>(Default);
